import { motion } from "framer-motion";

export const ThrowArrows = ({ throws, players, gap, width, playId, still }) => (
  <g style={{ pointerEvents: "none" }}>
    {throws.map((t) => {
      const a = players[t.src]?.pt;
      const b = players[t.dst]?.pt;
      if (!a || !b) return null;
      const dx = b[0] - a[0];
      const dy = b[1] - a[1];
      const len = Math.hypot(dx, dy);
      if (len < 1) return null;
      const g = Math.min(gap, len * 0.3);
      const ux = dx / len;
      const uy = dy / len;
      const x1 = a[0] + ux * g;
      const y1 = a[1] + uy * g;
      const x2 = b[0] - ux * g * 1.15;
      const y2 = b[1] - uy * g * 1.15;
      return (
        <motion.line
          key={`${playId}-${t.order}`}
          data-testid={`throw-arrow-${t.order}`}
          x1={x1} y1={-y1} x2={x2} y2={-y2}
          stroke="#fff" strokeWidth={width} strokeDasharray={`${width * 3} ${width * 2}`}
          strokeLinecap="round" markerEnd="url(#arrowhead)" className={still ? "" : "throw-flow"}
          initial={still ? false : { opacity: 0 }} animate={{ opacity: 1 }}
          transition={{ delay: 0.85 + t.order * 0.45, duration: 0.35 }}
        />
      );
    })}
  </g>
);
